import { DialogueSnapshot, Message } from 'lib/apiClient'

export const convertDialogueSnapshotsToMessageList = (
  dialogueSnapshots: DialogueSnapshot[] | undefined,
): Message[] => {
  if (!dialogueSnapshots) {
    return []
  }
  return dialogueSnapshots.map(snapshot => snapshot.messages).flat()
}

export const groupMessagesByDate = (
  assistantConversation: Message[],
  dateFormat: (input: Date | number) => string,
): Record<string, Message[]> => {
  const groupedConversation: Record<string, Message[]> = assistantConversation.reduce(
    (acc, message) => {
      const dateKey = dateFormat(new Date(message.created))

      if (!acc[dateKey]) {
        acc[dateKey] = []
      }

      acc[dateKey].push(message)
      return acc
    },
    {},
  )

  return groupedConversation
}

export const extractTextFromHtml = (stringToDecode: string): string => {
  const parser = new DOMParser()
  const document = parser.parseFromString(stringToDecode, 'text/html')
  return document.documentElement.textContent ?? ''
}
